import styled from 'styled-components';
import {useSelector} from 'react-redux';

// @ts-expect-error config needs to be rewritten as ts
import {isJustEat} from '~/shared/config';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import orangeSmLogoUrl from '~/assets/images/orange-sm-logo.svg';
import orangeMdLogoUrl from '~/assets/images/orange-md-logo.svg';
import jeOrangeSmLogoUrl from '~/assets/images/je-orange-sm-logo.svg';
import orangeLgLogoUrl from '~/assets/images/orange-lg-logo.svg';
import jeOrangeLgLogoUrl from '~/assets/images/je-orange-lg-logo.svg';
import govOrangeLgLogoUrl from '~/assets/images/gov-orange-lg-logo.svg';
import {getLocalizationService} from '~/shared/services/localisationService';
import {selectIsGovCompanyUser} from '~/shared/store/selectors';
import {useIsMinLargeMobile, useIsMinLargeTablet} from '~/shared/hooks/deviceInfo';
import {Link} from '~/shared/router';
import {defaultStartPage} from '~/shared/services/navigation';

const SharedLogoCss = styled(ImageWithAlt)`
  cursor: pointer;
`;

const SmOrangeLogo = styled(SharedLogoCss).attrs({
  src: orangeSmLogoUrl,
  width: 24,
  height: 24,
})``;

const MdOrangeLogo = styled(SharedLogoCss).attrs({
  src: orangeMdLogoUrl,
  width: 31,
  height: 39,
})``;

const JeSmOrangeLogo = styled(SharedLogoCss).attrs({
  src: jeOrangeSmLogoUrl,
  width: 31,
  height: 39,
})``;

const LgOrangeLogo = styled(SharedLogoCss).attrs({
  src: orangeLgLogoUrl,
  width: 108,
  height: 32,
})``;

const JeOrangeLogo = styled(SharedLogoCss).attrs({
  src: jeOrangeLgLogoUrl,
  width: 108,
  height: 32,
})``;

const GovLgOrangeLogo = styled(SharedLogoCss).attrs({
  src: govOrangeLgLogoUrl,
  width: 108,
  height: 39,
})``;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const Logo = ({isHardLogoClick}: {isHardLogoClick: boolean}) => {
  const {t} = getLocalizationService();
  const startPageLink = defaultStartPage();

  const isMinLargeMobile = useIsMinLargeMobile();
  const isMinLargeTablet = useIsMinLargeTablet();

  const isGovCompanyUser = useSelector(selectIsGovCompanyUser);

  if (isJustEat) {
    return (
      <StyledLink data-id="main-header-logo" href={startPageLink} hard={isHardLogoClick}>
        {!isMinLargeMobile && <JeSmOrangeLogo alt="Just Eat" />}
        {isMinLargeMobile && <JeOrangeLogo alt="Just Eat" />}
      </StyledLink>
    );
  }

  return (
    <StyledLink data-id="main-header-logo" href={startPageLink} hard={isHardLogoClick}>
      {isGovCompanyUser && isMinLargeTablet ? (<GovLgOrangeLogo alt={t('10bis')}/>) : (
        <>
          {!isMinLargeMobile && !isMinLargeTablet && <SmOrangeLogo alt={t('10bis')} />}
          {isMinLargeMobile && !isMinLargeTablet && <MdOrangeLogo alt={t('10bis')} />}
          {isMinLargeTablet && <LgOrangeLogo alt={t('10bis')} />}
        </>
      )}
    </StyledLink>
  );
};

export default Logo;
